import styled from 'styled-components';

const IconWrapper = styled.div`
  display: flex;
  background: #fff;
`;

export default IconWrapper;
